import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/shared/Link'
import ProductState from 'components/shared/ProductState'
import Heading from 'components/shared/Heading'
import {Desktop} from 'components/shared/Responsive'

import './index.scss'

const AddressListing = ({products, segment, address, broker, link, actions}) => {
  return (
    <div className="address-listing">
      <div className="segment" style={{backgroundColor: segment.backgroundColor}}>
        <Link to={link}><img src={segment.iconUrl} alt={segment.name} /></Link>
      </div>
      <div className="details">
        <div className="listing-heading">
          <Heading level={2}><Link to={link}>{address}</Link></Heading>
          {!!broker && <div>{broker}</div>}
        </div>
        {!!products && (
          <Desktop>
            <p>Bestilte produkter:</p>
            <div className="products">
              {products.map((product, i) => (
                <div key={i}>
                  {product.name} {product.quantity ? `(${product.quantity})` : ''}
                  <ProductState product={product} />
                </div>
              ))}
            </div>
          </Desktop>
        )}
      </div>
      <div className="actions">
        {actions}
      </div>
    </div>
  )
}

AddressListing.propTypes = {
  products: PropTypes.array,
  segment: PropTypes.object.isRequired,
  address: PropTypes.string.isRequired,
  showBroker: PropTypes.string,
  actions: PropTypes.node.isRequired,
}

export default AddressListing
